__turbopack_context__.v({
  "blocksBackgroundColor": "RoundIcon-module-scss-module__CnoHCq__blocksBackgroundColor",
  "blocksFontColor": "RoundIcon-module-scss-module__CnoHCq__blocksFontColor",
  "roundIcon": "RoundIcon-module-scss-module__CnoHCq__roundIcon",
  "roundIconCalendar": "RoundIcon-module-scss-module__CnoHCq__roundIconCalendar",
  "roundIconClassroom": "RoundIcon-module-scss-module__CnoHCq__roundIconClassroom",
  "roundIconError": "RoundIcon-module-scss-module__CnoHCq__roundIconError",
  "roundIconFacebook": "RoundIcon-module-scss-module__CnoHCq__roundIconFacebook",
  "roundIconGoogle": "RoundIcon-module-scss-module__CnoHCq__roundIconGoogle",
  "roundIconInstagram": "RoundIcon-module-scss-module__CnoHCq__roundIconInstagram",
  "roundIconNewsFeed": "RoundIcon-module-scss-module__CnoHCq__roundIconNewsFeed",
  "roundIconO365": "RoundIcon-module-scss-module__CnoHCq__roundIconO365",
  "roundIconParentsquare": "RoundIcon-module-scss-module__CnoHCq__roundIconParentsquare",
  "roundIconPinterest": "RoundIcon-module-scss-module__CnoHCq__roundIconPinterest",
  "roundIconRss": "RoundIcon-module-scss-module__CnoHCq__roundIconRss",
  "roundIconTripadvisor": "RoundIcon-module-scss-module__CnoHCq__roundIconTripadvisor",
  "roundIconTwitter": "RoundIcon-module-scss-module__CnoHCq__roundIconTwitter",
  "roundIconVimeo": "RoundIcon-module-scss-module__CnoHCq__roundIconVimeo",
  "roundIconYelp": "RoundIcon-module-scss-module__CnoHCq__roundIconYelp",
  "roundIconYoutube": "RoundIcon-module-scss-module__CnoHCq__roundIconYoutube",
  "secondaryNavBackgroundColor": "RoundIcon-module-scss-module__CnoHCq__secondaryNavBackgroundColor",
  "themeBackgroundColor": "RoundIcon-module-scss-module__CnoHCq__themeBackgroundColor",
  "themeFontColor": "RoundIcon-module-scss-module__CnoHCq__themeFontColor",
  "themeFontFamily": "RoundIcon-module-scss-module__CnoHCq__themeFontFamily",
});
